<template>
  <div>
    <!-- 公共picker -->
    <md-picker1
      ref="picker0"
      v-model="isPickerShow0"
      :data="typeList"
      :cols="cols"
      :is-cascade="true"
      :default-index="pickerDefaultIndex"
      :default-value="pickerDefaultValue"
      :isShowAbountButton="isShowAbountButton"
      @confirm="onPickerConfirm1()"
      @setAbountTime="setAbountTime"
      :large-radius="false"
      @initialed="getList"
      :keep-index="true"
      :title="title"
    ></md-picker1>
    <!-- <div class="inputdiv">
      <van-uploader ref="cupfiled"></van-uploader>
    </div>-->

    <div class="inputdiv">
      <input
        id="cupFileid"
        ref="upfile"
        type="file"
        @change="fileChange"
        accept="image/*, application/msexcel, application/msword, application/pdf, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
        multiple="multiple"
      />
    </div>

    <warningModal v-if="showmodal" @closeModal="closeModal"></warningModal>
  </div>
</template>
<script>
import Vue from "vue";
import { Uploader } from "vant";
Vue.use(Uploader);
import mdPicker from "../../components/picker/cuspicker";
import API from "../../service/index";
import commonAPI from "../../utils/common";
import store from "../../store/index";
import warningModal from '../../pages/appraise/appraiseNew/components/warningModal';
export default {
  components: {
    "md-picker1": mdPicker,
    warningModal,
  },
  props: {
    isShowAbountButton: {
      // 控制显示是否有自定义按钮
      type: Boolean,
      default: false,
    },
    typeList: {
      // 数据源
      type: Array,
      default: null,
    },
    cols: {
      // 列数
      type: Number,
      default: 1,
    },
    title: {
      type: String,
      default: "",
    },
    monitorType: {
      type: String,
      default: () => {
        return "";
      },
    },
    year: {
      type: [String, Number],
      default: () => {
        return 2020;
      },
    },
    quarter: {
      type: [String, Number],
      default: () => {
        return 0;
      },
    },
    area: {
      type: String,
      default: () => {
        return "";
      },
    },
    id: {
      type: String,
      default: () => {
        return "";
      },
    },
    needEmit: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
  },
  data() {
    return {
      isPickerShow0: false,
      pickerData0: [],
      pickerDefaultIndex: [],
      pickerDefaultValue: [],
      fielKind: {},
      fieldType: "",
      temEvent: null,
      showmodal: false
    };
  },
  methods: {
    resetFile() {
      if (this.temEvent) {
        this.temEvent.target.value = "";
      }
    },
    closeModal(){
      this.showmodal = false;
    },
    getList() {
      var valus = this.$refs.picker0.getColumnValue();
      console.log(valus);
    },
    setAbountTime() {
      this.$emit("showRangTime");
      this.isPickerShow0 = false;
    },
    showPicker() {
      // this._initFresh();
      this.isPickerShow0 = true;
    },
    onPickerConfirm1() {
      const values = this.$refs.picker0.getColumnValues();
      // console.log("-----选中的底部值:", values);
      this.$emit("getTypeValue", values);
      this.fielKind = values;
      this.fieldType = values[0].code;
      if (this.monitorType === "A2") {
        // this.$refs.cupfiled.click();
        const a = document.querySelector("#cupFileid");
        if (a) {
          // console.log("----进类型组件内部---版本v-1.1.1");
          a.click();
        }
      }
    },
    _initFresh() {
      // if(this.cols==3){
      //     this.pickerDefaultIndex = [];
      // }
      this.$refs.picker0.refresh();
    },
     openWindow(title, path) {
      window.yyn.invokeJSB(
        "openWindow",
        {
          openUrl: this.globalApp.getSystemInfo().host + "web/#" + path,
          isFullScreen: 0,
          setTitle: title,
          needLoading: 1,
        },
        (cb) => {
          console.log(cb, "callback");
        }
      );
    },
    fileChange(event) {
      this.tempFile = [];
      this.tempFileList = [];
      this.tempFile = event.target.files;
      this.temEvent = event;
      if (this.tempFile.length <= 0) {
        return false;
      }
      if (this.tempFile.length > 10) {
        this.$toast("最多可上传10个附件文件");
        return false;
      }
       for( let i = 0 ; i< this.tempFile.length; i++){
         if(this.tempFile[i].type !== 'application/pdf'){
           //提示 只能选PDF
           this.showmodal = true;
           this.$refs.upfile.value = null;
            return false;
         }
      }
      API.getCOStoken({}).then((res) => {
        // console.log("---token:", res);
        this.cosArg = res.data;
        this.cos = new COS({
          getAuthorization: function (options, callback) {
            callback({
              TmpSecretId: res.data.tmpSecretId,
              TmpSecretKey: res.data.tmpSecretKey,
              XCosSecurityToken: res.data.sessionToken,
              ExpiredTime: res.data.expiredTime,
            });
          },
        });
        this.uploadFile();
      });
    },
    async uploadFile() {
      let cosKey = "";
      const _this = this;
      // console.log("this.tempFile:", this.tempFile);
      store.dispatch("refund/setLoading", true);
      for (let i = 0; i < this.tempFile.length; i++) {
        let cosKey = `${commonAPI.getProcess()}/${new Date().getTime()}/${
          this.tempFile[i].name
        }`;
        // console.log('-----单个文件对象:', this.tempFile[i]);

        _this.cos.putObject(
          {
            Bucket: _this.cosArg.bucket,
            Region: _this.cosArg.region,
            Key: cosKey,
            Body: _this.tempFile[i],
            onHashProgress: function (progressData) {
              console.log("校验中", JSON.stringify(progressData));
            },
            onProgress: function (progressData) {
              console.log("上传中", JSON.stringify(progressData));
            },
          },
          (err, res) => {
            // console.log(err, res);
            // console.log("----上传之后返回的结果：", res);
            console.log('----成功:', res);
            console.log('---失败:', err);
            if (!err) {
              let name = this.tempFile[i].name.substring( 0, this.tempFile[i].name.lastIndexOf(".") );
               let filetype =  _this.tempFile[i].name.substring( _this.tempFile[i].name.lastIndexOf(".") + 1, _this.tempFile[i].name.length);
              let obj = {
                fileName: name,
                // fileType: commonAPI.getFileType(_this.tempFile[i].type),
                fileType: commonAPI.getFileType(filetype),
                fileSize: commonAPI.fixBtoKBorMB(_this.tempFile[i].size),
                fileSource: "app",
                fileKind: _this.fieldType,
                filePath: cosKey,
                fileUrl: res.Location,
                fileKindCN: _this.fielKind ? _this.fielKind[0].text : "",
              };
              _this.tempFileList.push(obj);
              // console.log("-----类型组件i:", i);
              // console.log("----类型组件length:", this.tempFile.length);
              // console.log("-----不是ture:", _this.needEmit);
              if (i + 1 >= _this.tempFile.length) {
                store.dispatch("refund/setLoading", false);
                console.log('查看上传的文件:', _this.tempFileList);
                if (_this.needEmit) {
                  _this.$emit("fields", _this.tempFileList);
                } else {
                  _this.$router.push({
                    path: "/appraise/add_enclosure",
                    query: {
                      fields: _this.tempFileList,
                      monitorType: _this.monitorType,
                      fielKind: _this.fielKind,
                      year: _this.year,
                      quarter: _this.quarter,
                      area: _this.area,
                      id: _this.id,
                      submitAuth: _this.submitAuth,
                    },
                  });
                }
              }
            }
          }
        );
      }
    },
  },
};
</script>
<style>
/* 初始化插件的样式 */
.mint-datetime-action {
  width: 30%;
}
.picker-toolbar span:nth-child(1) {
  color: #999;
}
.picker-toolbar span:nth-child(2) {
  color: #4b77b0;
}
.mint-datetime .picker-toolbar {
  border: none;
}
.md-popup-title-bar[data-v-6bac428c] {
  height: 40px;
}
.md-popup-title-bar .title-bar-left[data-v-6bac428c],
.md-popup-title-bar .title-bar-right[data-v-6bac428c] {
  font-size: 14px;
}
.md-popup-title-bar .title-bar-left[data-v-6bac428c],
.md-popup-title-bar .title-bar-right[data-v-6bac428c] {
  height: 40px;
}
.md-popup-title-bar > div[data-v-6bac428c] {
  padding-top: 20px;
}
.md-picker-column-item .column-list .column-item {
  font-size: 16px;
}
.md-picker-column-item .column-list .column-item {
  font-size: 16px !important;
}
</style>
<style lang="less" scoped>
.inputdiv {
  display: none;
}
</style>
